<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <transition name="fade">
          <b-card no-body v-if="show">
            <div slot="header">
              <i class="fa fa-map-o"></i> Map
            </div>
            <b-row class="flex-nowrap no-gutters">
              <b-col class="col-md-3 col-xs-5">
                <b-card-body>
                  <b-form>
                        <b-tabs v-model="tabIndex">
                          <b-tab title="Search by location" active>
                             <b-form-group>
                                <b-input-group>
                                <!-- <b-form-input type="text" size="sm" placeholder="Origin location"></b-form-input> -->
                                  <gmap-autocomplete
                                      v-focus
                                      ref='origin'
                                      @place_changed="setPlace($event, 'origin')"
                                      v-on:keyup.enter="onEnterClick"
                                      placeholder="Search starting point ..."
                                      :componentRestrictions="options"
                                      class="form-control">
                                  </gmap-autocomplete>
                                  <!-- Attach Right button -->
                                   <b-input-group-append>
                                     <b-button variant="secondary" @click="initMapClickEventHandler('origin')" title="Select point of interest on the map" ><i class="fa fa-map-marker"></i></b-button>
                                     <b-button @click="searchLatLng('origin')" title="Search GPS coordinates" variant="secondary"><i class="fa fa-search"></i></b-button>
                                  </b-input-group-append>

                                  <!-- <b-input-group-append>
                                     <b-button variant="secondary" @click="findLocation('origin')"><i class="fa fa-search"></i></b-button>
                                  </b-input-group-append> -->
                                </b-input-group>
                              </b-form-group>

                               <!-- add waypoint -->
                               <b-form-group v-for="(stop, index) in stops" :key="`stop_${index}`">
                                <b-input-group>
                                  <gmap-autocomplete
                                      ref="stop"
                                      v-focus
                                      @place_changed="setWaypoint"
                                      placeholder="Search stop ..."
                                      :componentRestrictions="options"
                                      class="form-control" :data="stop">
                                  </gmap-autocomplete>
                                  <!-- Attach Right button -->
                                  <b-input-group-append>
                                      <b-button variant="secondary" @click="initMapClickEventHandler(`${index}`)"><i class="fa fa-map-marker"></i></b-button>
                                      <b-button @click="searchLatLng(`${index}`)" variant="secondary" title="Search GPS coordinates"><i class="fa fa-search"></i></b-button>
                                    <!-- <b-button variant="secondary" @click="findLocation(`${index}`)"><i class="fa fa-map-marker"></i></b-button> -->
                                    <!-- <b-button @click="addMarker" variant="primary"><i class="fa fa-search"></i></b-button> -->
                                    <!-- <b-input-group-append><b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text></b-input-group-append> -->
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>

                              <b-form-group>
                                <b-input-group>
                                  <gmap-autocomplete
                                      ref='destination'
                                      @place_changed="setPlace($event, 'destination')"
                                      placeholder="Search destination ..."
                                      :componentRestrictions="options"
                                      class="form-control">
                                  </gmap-autocomplete>
                                  <!-- Attach Right button -->
                                  <b-input-group-append>
                                      <b-button variant="secondary" @click="initMapClickEventHandler('destination')"><i class="fa fa-map-marker"></i></b-button>
                                       <b-button @click="searchLatLng('destination')" variant="secondary" title="Search GPS coordinates"><i class="fa fa-search"></i></b-button>
                                    <!-- <b-input-group-append><b-input-group-text><i class="fa fa-flag-checkered"></i></b-input-group-text></b-input-group-append> -->
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>

                          </b-tab>

                          <b-tab title="Upload GPS locations">

                            <b-form-group>
                               <file-upload
                                    ref="fileUpload"
                                    :have-desc="false"
                                    title=""
                                    accept=".csv, .txt"
                                    @event-handler="fileUploadEventHandler($event)">
                                  </file-upload>
                            </b-form-group>

                          </b-tab>

                        </b-tabs>
                      </b-form-group>
                    <br>
                    <div class="form-group form-actions">
                      <b-button @click="findDirection" type="button" size="sm" variant="secondary" :disabled="isEnableDirection"><i class="fa fa-automobile"></i> Show Route</b-button>
                      <b-button @click="addStop" type="button" size="sm" variant="secondary">Add Stop</b-button>
                      <b-button @click="resetForm" type="button" size="sm" variant="secondary">Reset</b-button>
                    </div>
                    <br>
                    <div slot="footer">
                      <i class="fa fa-lightbulb-o text-warning fa-1x" style="padding-bottom: 15px"></i> <small>Click <b>Capture</b> button to confirm the route.</small>&nbsp;<br>
                        <b-button @click="captureEventHandler" type="button" size="sm" variant="success" :disabled="disabledCapture"><i class="fa fa-camera"></i> Capture</b-button>&nbsp;

                      <b-button @click="closeEventHandler" type="button" size="sm" variant="secondary"><i class="fa fa-close"></i> Close</b-button><br>

                      <!-- <b-button @click="captureEventHandler" type="button" size="sm" variant="success">Capture</b-button><br>
                      <b-button @click="closeEventHandler" type="button" size="sm" variant="secondary"><i class="fa fa-close"></i> Close</b-button><br> -->
                    </div>
                  </b-form>
                </b-card-body>
              </b-col>
              <b-col class="col" ref="capture">
                    <div id="floating-panel" class="col-md-3 form-row">
                      <label class="col-form-label"><small>Mode of Travel</small></label>
                      <div class="col-sm-7">
                        <b-form-select v-model="travelMode" size="sm" @change="travelModeChangeEventHandler">
                            <option value="DRIVING">Driving</option>
                            <option value="WALKING">Walking</option>
                        </b-form-select>
                      </div>
                    </div>

                    <!--  <b-form-group>
                     <b>Mode of Travel: &nbsp;</b>
                      <b-form-select v-model="travelMode" size="sm">
                        <option value="DRIVING">Driving</option>
                        <option value="WALKING">Walking</option>
                      </b-form-select>
                    </b-form-group>                     -->
                    <!-- </div> -->
                  <gmap-map
                    :center="defaultLocation" :zoom="7"
                    map-type-id="roadmap"
                    :style="mapStyles" ref="mapRef">
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :animation=2
                      :clickable="true"
                      :draggable="true"
                      @dragend="dragend(index, $event)"
                      @click="center=m.position"
                      :ref="markerRef">
                      </gmap-marker>
                    </gmap-map>
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as constants from '@/store/constants'
import { gmapMixin } from '@/mixins/gmapMixin'
import * as types from '@/store/types'
import toast from '@/mixins/toast'
import FileUpload from '@/components/file-upload/FileUpload'
import UploadService from '@/api/UploadService'

export default {
  components: {
    FileUpload
  },
  mixins: [gmapMixin],
  props: {
    options: { type: Object,
               default() {
              return { country: 'YE' }
      }
    }
  },
  data () {
    return {
      output: null,
      selected: [], // Must be an array reference!
      show: true,
      disabledCapture: true,
      showRouteInfo: false,
      routeInfoHeader: null,
      overview_polyline: null,
      polyline: [],
      all_overlays: [],
      markers: [],
      old_markers: [],  // store previous markers
      places: [],
      currentPlace: null,
      targetObject: null,
      mapStyles: 'width: 100%; height:' + (window.innerHeight - 250) + 'px',
      routeInfoStyle: 'padding:0px;position:relative; height:300px; overflow-y:scroll;',
      map: null,
      markerRef: null,
      title: '0 km',
      total: 0,
      stops: [],
      waypoints: [],
      currentWaypoint: null,
      legs: [],
      directionsDisplay: null,
      searchAddressInput: '',
      defaultLocation: {lat:15.5, lng:47.5},
      segmentMarkers: [],
      center: null,
      latlng: null,
      lat: 0,
      lng: 0,
      origin: null,
      destination: null,
      tabIndex: 0,
      selectPOI: false,
      targetField: null,
      travelMode: 'DRIVING',
      directionsService: null
    }
  },
  computed: {

  },
  watch: {
    mapStyles () {
      // loaded.then(() => {
      //   var bounds = new google.maps.LatLngBounds()
      //   console.log(bounds)
      // })
    }
  },
  methods: {

    travelModeChangeEventHandler(e) {
        console.log(e)
        this.travelMode = e

        console.log(this.markers)

        if (this.old_markers.length > 0) {
            this.markers = this.old_markers
        }

        this.calculateAndDisplayRoute(this.directionsService, this.directionsDisplay, this.markers[0].position, this.markers[this.markers.length-1].position, this.waypoints)

    },

    async fileUploadEventHandler(event) {
      const notificationId = this.$store.state.notificationId
      const requestTypeId = this.$store.state.requestTypeId
      const category = "GPS_DOCUMENT"
      const $this = this
      const _self = this
      this.showUploadError = false

      let file = event.file
      if (!file) return

      // validate if file exceeds 1mb
      if (file.size >= constants.FILE_MAXIMUM_SIZE) {
          this.showUploadError = true
          return
      }

      let formData = new FormData()
      formData.append('file', file, file.name)

      this.showUploadAlert = true

      await UploadService.gps(formData, notificationId, requestTypeId, category, event.description).then( (resp) => {
          if (resp && resp.length > 0) {

              _self.drawCustomRoute(resp)


              // // draw polyline
              // var polyline = new google.maps.Polyline({
              //   path: resp,
              //   geodesic: true,
              //   strokeColor: '#426289',
              //   strokeOpacity: 1.0,
              //   strokeWeight: 3,
              //   clickable: false,
              //   editable: false,
              //   zIndex: 1
              // });

              // polyline.setMap(_self._map)

              // _self.disabledCapture = false

              // let o = polyline.getPath().getArray()
              // let polyLengthInMeters = google.maps.geometry.spherical.computeLength(o);


              // _self.overview_polyline = google.maps.geometry.encoding.encodePath(polyline.getPath());
              // _self.polyline = o

              // console.log( "encodeString: "+ _self.overview_polyline )

              // for (var i = 0; i < o.length; i++) {
              //   console.log(o[i].lat() +", "+ o[i].lng())

              //   if (i === 0) {
              //       _self.markers.push({
              //           position: {
              //             lat: o[i].lat(),
              //             lng: o[i].lng()
              //           }
              //       })
              //   }
              //   else if (i+1 == o.length) {
              //        _self.markers.push({
              //           position: {
              //             lat: o[i].lat(),
              //             lng: o[i].lng()
              //           }
              //       })
              //   }
              // }

              // // calculate 20km segment
              // let totalDistanceKM = polyLengthInMeters/1000;
              // let segment = (totalDistanceKM / 20);
              // let totKM = 20;

              // for (var i=0; i < segment; i++) {

              //   let obj = polyline.GetPointAtDistance(totKM*1000)
              //   if (obj !== null) {
              //       _self.createMarker(polyline.GetPointAtDistance(totKM*1000), totKM +"km",'yellow');
              //   }

              //   totKM+=20;
              // }

              // this.$store.commit(types.MUTATE_MODIFIED, true)
              // this.isUploadReady = true

              // setTimeout(function () {
              //     this.showUploadAlert = false
              //     this.$refs.fileUpload.reset()
              // }.bind(this), 3000)

          }
      })
    },

    drawCustomRoute(resp) {

      const _self = this

      // draw polyline
      var polyline = new google.maps.Polyline({
        path: resp,
        geodesic: true,
        strokeColor: '#426289',
        strokeOpacity: 1.0,
        strokeWeight: 3,
        clickable: false,
        editable: false,
        zIndex: 1
      });

      polyline.setMap(_self._map)

      _self.disabledCapture = false

      let o = polyline.getPath().getArray()
      let polyLengthInMeters = google.maps.geometry.spherical.computeLength(o);
      _self.overview_polyline = google.maps.geometry.encoding.encodePath(polyline.getPath())
      _self.polyline = o

      console.log( "encodeString: "+ _self.overview_polyline )

      for (var i = 0; i < o.length; i++) {
        console.log(o[i].lat() +", "+ o[i].lng())

        if (i === 0) {
            _self.markers.push({
                position: {
                  lat: o[i].lat(),
                  lng: o[i].lng()
                }
            })
        }
        else if (i+1 == o.length) {
             _self.markers.push({
                position: {
                  lat: o[i].lat(),
                  lng: o[i].lng()
                }
            })
        }
      }

      // calculate 20km segment
      let totalDistanceKM = polyLengthInMeters/1000;
      let segment = (totalDistanceKM / 20);
      let totKM = 20;

      for (var i=0; i < segment; i++) {

        let obj = polyline.GetPointAtDistance(totKM*1000)
        if (obj !== null) {
            _self.createMarker(polyline.GetPointAtDistance(totKM*1000), totKM +"km",'yellow');
        }

        totKM+=20;
      }

    },

    initMapClickEventHandler(e) {
      this.targetField = e
      this.selectPOI = true
      this._map.setOptions({draggableCursor:'crosshair'})
    },

    searchLatLng(field) {

      let value = null

      if (field === 'origin')
          value = this.$refs.origin.$el.value
      else if (field == 'destination')
          value = this.$refs.destination.$el.value
      else
          value = this.$refs.stop[field].$el.value

      let latlngStr = value.split(',', 2)

      console.log("latlng: "+ latlngStr)
      let lat = parseFloat(latlngStr[0].trim())
      let lng = parseFloat(latlngStr[1].trim())

      if (utils.isFloat(lat)  && utils.isFloat(lng)) {
        this.latlng = lat+","+lng
        this.findLocation(field)

      }
      else {
        toast.error( "Invalid GPS coordinates. ", "Error")
        if (field === 'origin')
            this.$refs.origin.$el.focus()
        else if (field === 'destination')
            this.$refs.destination.$el.focus()
        else
            this.$refs.stop[field].$el.focus()
      }
    },

    mapClickEventHandler(e) {

      console.log(e)
      console.log(this.targetField)
      if (this.selectPOI) {
          this.selectPOI = false
          // let marker = {
          //         lat: e.latLng.lat(),
          //         lng: e.latLng.lng()
          //     }
          //this.markers.push({ position: marker })

          if (e.position === undefined) {
              this.lat =  e.latLng.lat()
              this.lng = e.latLng.lng()
          }
          else {
            this.lat = e.position.lat().toFixed(6)
            this.lng = e.position.lng().toFixed(6)
          }

          this.latlng = this.lat +", "+ this.lng
          this._map.setOptions({draggableCursor:''});
          this.findLocation(this.targetField)
      }
    },

    closeEventHandler() {
      this.$router.replace('/forms/'+ this.$route.query.param)
    },
    // receives a place object via the autocomplete component
    setPlace (place, target) {
      this.currentPlace = place
      this.targetObject = target
      this.addMarker()
    },
    captureEventHandler () {

      // var poly = google.maps.geometry.encoding.decodePath('enc:_v`mA{lwqGsGwe@g_Bw^qyDdpBukAl_BudAzb@g]aA_WeFuoAneAssDoB_nB|x@mvFbzC_uFfzEk{@vnAayCz`ActBhdA{`G|lBohCxb@wuAfEaeElvG{zEx{BuzDvr@c`HdiCglDeWohAwJw{@jTigAeNoiBim@unAcrDsmBibB{tBoAc{A}i@uwEe\e{BwaAgu@y_@ofBzYgjBej@uTsl@ko@FcwEl}BizBlp@gc@_D]gg@agAmd@{_AmpA__Ckh@_hAaFem@zy@stAtjAkj@|rBuE|iBc@plAxZjyAi^vw@fKthAyr@zu@qf@h`AkoAbUcw@tDsy@eh@yeC{i@qp@_t@gwAzJqeD~~AeqDrgBshChiAi}A~I~F`}B_`AnsFec@paEtWdpBmPjsAmw@zmEwdA~aA_yA`uBzWh~A`Wt}@|g@b]fa@pl@fPr{@{g@veAak@|YsTbl@zBzcBpPpkAck@ncBdpA|hDme@vrCgCnhA}vAni@}t@fy@p_@`j@co@gLp{AhgAr`@lo@gXfyAwZjxAo|AdqByHtqC{i@lZwAhg@oXtz@oe@lzAafAn~@jFha@sStZiwA`yA}UmLky@xLuIw@wDef@cc@kW{hE}Y{xCd_@oxDmJomCgx@{kA}_Bok@i_Dq]{Su^w_AcGzKqc@{Vqe@ck@k[{X_a@bVsqA}g@{eAmD@~h@a]yL}f@u`Ccs@we@tMgr@|Qq]s`@wr@hK__@wyB{vB{eE_cEsyEkwAooAuaBbMogBoT_pCaPuqCnh@}uAwEsqAbDsvBh_@is@aNow@vo@woAljAgoAvmDiaDhgA}jBtf@cz@v_@y\~GjO~TukAcv@wcBgFaeA_g@m`ArRu\aOyc@eIoM_b@iEgPsfA~Dgg@sYeTktB{WkdAki@_dAhX_hByDmp@}PiGus@is@s{@amAa`AsxBkoAwhCy}@uzAe\_aAy{@uR{^q]oFmf@kIwYnk@hPzhAkN|eAf^`jD_b@rjBew@|kBs`BzfHa`@vaFw_@j}AuqDt{IkwBrfC`RrFfm@xM~z@[h~Dx[vnDbs@lgD`}BnG~{@xoCtlAhTbzAarAiI}|@e|@{Swe@a[wbAumBdj@ukBfaAusAwEydAsPki@|]yf@|{@{xAp[miE~fAcb@zBsfBrJgkI`uCm|Ch~AotExv@ygBoMqvCpw@{}JfyEoxF|_BkVtiENxiA~k@f^~]_KbZ~RyDt|C_yBpg@a}@zUpOnv@rp@hpB}Uby@woAz^cuAo@axA_~@bB~nBujA~_B&key=AIzaSyAw-RrzY2H4pCwu9aiUW3B6LPBYmWfirPo')

      // console.log(poly)
      //  for (var idx in poly) {
      //       var l = poly[idx]
      //       console.log(l.lat().toFixed(6) +","+ l.lng().toFixed(6)+", 0")
      //  }

      if (this.polyline.length > 0) {
          this.captureCustomRouteEventHandler()
      }
      else {
          this.captureNormalRouteEventHandler()
      }

    },

    captureNormalRouteEventHandler() {

      let response = this.directionsDisplay.getDirections()
        // console.log('*** Response ***');
        // console.log(response)
        console.log('Zoom Level: '+ this._map.getZoom()-1 )
        // console.log('Orgin: '+ response.request.origin.location.lat() +', '+ response.request.origin.location.lng() )
        // console.log('Destination: '+ response.request.destination.location.lat() +', '+ response.request.destination.location.lng() )
        // console.log('Polyline: '+ response.routes[0].overview_polyline)
        //
        // Set static map URL
        let staticMapURL = "https://maps.googleapis.com/maps/api/staticmap?zoom=::ZOOM::&scale=2&size=1024x1024&maptype=::MAP_TYPE::&format=png&visual_refresh=true&::MARKERS::&path=enc:::PATH::&key=AIzaSyAw-RrzY2H4pCwu9aiUW3B6LPBYmWfirPo"
        
        staticMapURL = staticMapURL.replace("::PATH::", this.encodePolyline(response.routes[0].overview_polyline))

        let staticMapURLSat = staticMapURL
        //staticMapURL = staticMapURL.replace("::CENTER::", this.center)
        staticMapURL = staticMapURL.replace("::MAP_TYPE::", 'roadmap')  // this._map.getMapTypeId()
        staticMapURL = staticMapURL.replace("::ZOOM::", 8) //  // 8

        staticMapURLSat = staticMapURLSat.replace("::MAP_TYPE::", 'satellite')
        staticMapURLSat = staticMapURLSat.replace("::ZOOM::", 18)

        let _markers = null
        let _markerSat = null
        if (response.request.origin.location)
            _markers = "markers=size:mid|color:0xff0000|label:A|"+ response.request.origin.location.lat() +','+ response.request.origin.location.lng()
        else
            _markers = "markers=size:mid|color:0xff0000|label:A|"+ response.request.origin.lat() +','+ response.request.origin.lng()

        let alpha ="ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        let i=0

        console.log("** waypoints **")
        console.log(JSON.stringify(response.request.waypoints[0]))
        console.log("** waypoints **")
        for (i=0; i< response.request.waypoints.length; i++) {
            if (response.request.waypoints[i].location.location)
                _markers +=  "&markers=size:mid|color:0xff0000|label:"+ alpha.charAt(i+1) +"|"+ response.request.waypoints[i].location.location.lat() +','+ response.request.waypoints[i].location.location.lng()
            else
                _markers +=  "&markers=size:mid|color:0xff0000|label:"+ alpha.charAt(i+1) +"|"+ response.request.waypoints[i].location.lat() +','+ response.request.waypoints[i].location.lng()
        }

        // _markers +=  "&markers=size:mid|color:0xff0000|label:"+ alpha.charAt(i+1) +"|"+ response.request.destination.location.lat() +','+ response.request.destination.location.lng()

         if (response.request.destination.location)
            _markers +=  "&markers=size:mid|color:0xff0000|label:"+ alpha.charAt(i+1) +"|"+ response.request.destination.location.lat() +','+ response.request.destination.location.lng()
         else
            _markers +=  "&markers=size:mid|color:0xff0000|label:"+ alpha.charAt(i+1) +"|"+ response.request.destination.lat() +','+ response.request.destination.lng()


        console.log(_markers)

        if (response.request.destination.location) {
             _markerSat ="&markers=size:mid|color:0xff0000|label:"+ alpha.charAt(1) +"|"+ response.request.destination.location.lat() +','+ response.request.destination.location.lng()
             staticMapURLSat = staticMapURLSat.replace("::CENTER::", response.request.destination.location.lat() +','+ response.request.destination.location.lng())
        }
        else {
            _markerSat ="&markers=size:mid|color:0xff0000|label:"+ alpha.charAt(1) +"|"+ response.request.destination.lat() +','+ response.request.destination.lng()
            staticMapURLSat = staticMapURLSat.replace("::CENTER::", response.request.destination.lat() +','+ response.request.destination.lng())
        }

        // let departures = []
        // let arrivals = []
        let waypoints = []
        let travels = []
        let convoys = []
        let legs = response.routes[0].legs
        let dStartDate = this.$moment(this.$store.state.start_date).format('HH:mm:ss')
        let startTime = this.$moment(this.$store.state.start_date).format('HH:mm:ss')

        console.log("*startTime: "+ startTime)
        // let dRequestDate = this.$moment(this.$store.state.request_date, 'YYYY-MM-DD HH:mm')
        //let dRequestDate = this.$moment("2018-09-30T17:32:49+03:00", 'YYYY-MM-DD HH:mm')

        // var duration = this.$moment.duration(dStartDate.diff(dRequestDate))
        // var hours = Math.round(duration.asHours())
        // var days = Math.round(duration.asDays())

        // var temp = this.$momenttz(dStartDate, 'DD/MM/YYYY 16:30:00ZZ', 'Asia/Riyadh').format('DD/MM/YYYY 16:30:00ZZ')
        // var cutoffDate = this.$moment(temp, 'YYYY-MM-DD HH:mm')

        // console.log("cutoffDate: "+ cutoffDate)
        // console.log( "start date hour: "+ dStartDate.hour() )
        // console.log( "start date minues: "+ dStartDate.minutes() )
        // console.log( "cuttoff hour: "+ cutoffDate.hour() )
        // console.log( "cuttoff minutes: "+ cutoffDate.minutes() )


        // console.log( "total hours: "+ hours)
        // console.log( "total days: "+ days)

        // let dDate = this.$store.state.start_date
        // let aDate = this.$store.state.start_date
        // console.log("dStartDate: "+ dStartDate.format())
        // console.log("dRequestDate: "+ dRequestDate.format())

        let departureFormat = 'YYYY-MM-DDT'+ startTime +'Z'

        for (var idx in legs) {
            var l = legs[idx]

            if (idx == 0) {
                waypoints.push({ location: l.start_address,
                                 gps: l.start_location.lat().toFixed(6) + "," +
                                 l.start_location.lng().toFixed(6)
                               })
            }

            let arrivalFormat = 'YYYY-MM-DDT00:00:00Z'

            if (legs.length === 1 || parseInt(idx) === 0) {
                arrivalFormat = 'YYYY-MM-DDT18:00:00Z'
                // if (days == 2 && dStartDate.hour() >= cutoffDate.hour() ) {
                //    if (dStartDate.hour() > cutoffDate.hour()) {
                //        departureFormat = "YYYY-MM-DDT11:00:00+0300"
                //        arrivalFormat = "YYYY-MM-DDT18:00:00+0300"
                //    }
                //    else {
                //        departureFormat = "YYYY-MM-DDT06:00:00+0300"
                //        arrivalFormat = "YYYY-MM-DDT18:00:00+0300"
                //    }
                // }
                // else {
                //   arrivalFormat = "YYYY-MM-DDT18:00:00+0300"
                // }
            }
            // else if (parseInt(idx) === 0) {
            //    if (days == 2 && hours >= cutoffDate.hour() ) {
            //        if (hours > cutoffDate.hour()) {
            //            departureFormat = "YYYY-MM-DDT11:00:00ZZ"
            //            arrivalFormat = "YYYY-MM-DDT00:00:00ZZ"
            //        }
            //        else {
            //            departureFormat = "YYYY-MM-DDT06:00:00ZZ"
            //            arrivalFormat = "YYYY-MM-DDT00:00:00ZZ"
            //        }
            //    }
            // }
            else if (parseInt(idx) === legs.length-1) {
                //departureFormat = "YYYY-MM-DDT00:00:00+0300"
                arrivalFormat = "YYYY-MM-DDT18:00:00Z"
            }

            //this.$moment(this.nextWorkingDate).tz('Asia/Riyadh').format('YYYY-MM-DDT06:00:00ZZ')
            console.log("departureFormat: "+ departureFormat)
            console.log("arrivalFormat: "+ arrivalFormat)

            // this.$momenttz(selectedDate, 'DD/MM/YYYY 16:30:00ZZ', 'Asia/Riyadh').format('YYYY-MM-DDT16:30:00ZZ')
            let departureDate = this.$moment(this.$store.state.start_date).format( departureFormat )
            // let departureDate = this.$momenttz(this.$store.state.start_date, 'YYYY-MM-DD HH:mmZZ', 'Asia/Riyadh').format( departureFormat )
            let arrivalDate = this.$moment(this.$store.state.start_date).format( arrivalFormat )
            // let departureDate = this.$moment(this.$store.state.start_date).tz('Asia/Riyadh').format( departureFormat )
            // let arrivalDate = this.$moment(this.$store.state.start_date).tz('Asia/Riyadh').format( arrivalFormat )

            // let departureDate = this.$moment( new Date( dDate ) )
            //                           .format( departureFormat )
            // let arrivalDate = this.$moment( new Date( aDate) )
            //                           .format( arrivalFormat )

               // this.$momenttz(startDate).toDate(),
              convoys.push({ departure_location: l.start_address,
                             departure_date: departureDate,//this.$momenttz(departureDate).tz('Asia/Riyadh').format(),
                             //departure_date: this.$moment(departureDate, 'DD/MM/YYYY HH:mm:ss').toDate(),
                             departure_gps: l.start_location.lat().toFixed(6) + "," + l.start_location.lng().toFixed(6),
                             arrival_location: l.end_address,
                             arrival_date: arrivalDate,//this.$moment(arrivalDate).tz('Asia/Riyadh').format(),
                             //arrival_date: this.$moment(arrivalDate, 'DD/MM/YYYY HH:mm:ss').toDate(),
                             arrival_gps: l.end_location.lat().toFixed(6) + ","+ l.end_location.lng().toFixed(6),
                             total_distance: l.distance.text,
                             total_duration: l.duration.text
                           })
        }
        // console.log("*** convoys ***")
        // console.log(convoys)
        // get waypoints
        for (var idx in this.segmentMarkers) {
          let s = this.segmentMarkers[idx]
          waypoints.push( {location: s.title, gps: s.position.lat().toFixed(6) +"," +s.position.lng().toFixed(6) } )
        }

        // end location
        var l = legs[legs.length-1]
        waypoints.push({ location: l.end_address, gps: l.end_location.lat().toFixed(6) +","+ l.end_location.lng().toFixed(6) })

        staticMapURL = staticMapURL.replace("::MARKERS::", _markers)
        staticMapURLSat = staticMapURLSat.replace("::MARKERS::", _markers)

        console.log(staticMapURL)

        // store to state
        //this.$store.commit(types.MUTATE_MAP_MODIFIED, true)
        this.$store.commit(types.MUTATE_MODIFIED, true)
        this.$store.commit(types.MUTATE_MAP, { roadmap: staticMapURL, satellite: staticMapURLSat })
        this.$store.commit(types.MUTATE_WAYPOINTS, waypoints)
        this.$store.commit(types.MUTATE_CONVOYS, convoys)

        // this.$store.commit(types.MUTATE_UPDATE_DEPARTURES, departures)
        // this.$store.commit(types.MUTATE_UPDATE_ARRIVALS, arrivals)
        // this.$store.commit(types.MUTATE_UPDATE_TRAVELS, travels)
        // this.$router.replace('/forms/land-movement')
        this.$router.replace('/forms/'+ this.$route.query.param)

    },

    encodePolyline(polyline) {
      // Create a map of characters and their URL-encoded counterparts
      const encodeMap = {
        '`': '%60',
        '^': '%5E',
        '|': '%7C',
        '\\': '%5C',
        '[': '%5B',
        ']': '%5D'
      };

      // Replace each character in the provided polyline with its encoded equivalent
      const encodedPolyline = polyline.replace(/[`^|\\\[\]]/g, match => encodeMap[match]);

      // Return the encoded polyline
      return encodedPolyline;
    },
    captureCustomRouteEventHandler () {
        // let response = this.directionsDisplay.getDirections()

        // Set static map URL
        let staticMapURL = "https://maps.googleapis.com/maps/api/staticmap?zoom=::ZOOM::&scale=2&size=1024x1024&maptype=::MAP_TYPE::&format=png&visual_refresh=true&::MARKERS::&path=enc:::PATH::&key=AIzaSyAw-RrzY2H4pCwu9aiUW3B6LPBYmWfirPo"
        // Replace each character in overview_polyline with its encoded equivalent
        staticMapURL = staticMapURL.replace("::PATH::", this.encodePolyline(this.overview_polyline))

        let staticMapURLSat = staticMapURL
        staticMapURL = staticMapURL.replace("::MAP_TYPE::", 'roadmap')
        staticMapURL = staticMapURL.replace("::ZOOM::", 8)

        staticMapURLSat = staticMapURLSat.replace("::MAP_TYPE::", 'satellite')
        staticMapURLSat = staticMapURLSat.replace("::ZOOM::", 18)

        let _markers = "markers=size:mid|color:0xff0000|label:A|"+ this.markers[0].position.lat +','+ this.markers[0].position.lng
        _markers += "&markers=size:mid|color:0xff0000|label:B|"+ this.markers[1].position.lat +','+ this.markers[1].position.lng

        let waypoints = []
        let travels = []
        let convoys = []
        let legs = this.polyline
        let dStartDate = this.$moment(this.$store.state.start_date).format('HH:mm:ss')
        let startTime = this.$moment(this.$store.state.start_date).format('HH:mm:ss')
        let departureFormat = 'YYYY-MM-DDT'+ startTime +'Z'

        //for (var idx in legs) {
            var p1 = legs[0]
            var p2 = legs[1]
            waypoints.push({ location: p1.lat().toFixed(6) + "," + p1.lng().toFixed(6),
                             gps: p1.lat().toFixed(6) + "," + p1.lng().toFixed(6)
                           })

            let arrivalFormat = 'YYYY-MM-DDT00:00:00Z'

            if (legs.length === 1 || parseInt(idx) === 0) {
                arrivalFormat = 'YYYY-MM-DDT18:00:00Z'
            }
            else if (parseInt(idx) === legs.length-1) {
                arrivalFormat = "YYYY-MM-DDT18:00:00Z"
            }

            let departureDate = this.$moment(this.$store.state.start_date).format( departureFormat )
            let arrivalDate = this.$moment(this.$store.state.start_date).format( arrivalFormat )

            convoys.push({ departure_location: "Point A",
                             departure_date: departureDate,
                             departure_gps: p1.lat().toFixed(6) + "," + p1.lng().toFixed(6),
                             arrival_location: "Point B",
                             arrival_date: arrivalDate,
                             arrival_gps: p2.lat().toFixed(6) + ","+ p2.lng().toFixed(6),
                             total_distance: "",
                             total_duration: ""
                           })

        // get waypoints
        for (var idx in this.segmentMarkers) {
          let s = this.segmentMarkers[idx]
          waypoints.push( {location: s.title, gps: s.position.lat().toFixed(6) +"," + s.position.lng().toFixed(6) } )
        }

        // end location
        //var l = legs[legs.length-1]
        waypoints.push({ location: p2.lat().toFixed(6) + "," + p2.lng().toFixed(6),
                         gps: p2.lat().toFixed(6) + "," + p2.lng().toFixed(6)
                       })

        staticMapURL = staticMapURL.replace("::MARKERS::", _markers)
        staticMapURLSat = staticMapURLSat.replace("::MARKERS::", _markers)

        console.log("** staticMapURL: " + staticMapURL)

        // store to state
        this.$store.commit(types.MUTATE_MODIFIED, true)
        this.$store.commit(types.MUTATE_MAP, { roadmap: staticMapURL, satellite: staticMapURLSat })
        this.$store.commit(types.MUTATE_WAYPOINTS, waypoints)
        this.$store.commit(types.MUTATE_CONVOYS, convoys)
        this.$router.replace('/forms/'+ this.$route.query.param)
    },

    findLocation(field) {

      // reset marker
      //this.markers = []
      const $this = this
      var latlngStr = this.latlng.split(',', 2)
      let marker = {
                  lat: parseFloat(latlngStr[0]),
                  lng: parseFloat(latlngStr[1])
                }

       console.log("latlngStr: "+ this.latlng)

      //$this.$refs.origin.$el.value = results[0].formatted_address
      // $this.markers.push({ position: marker })
      var latlng = {lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1])}
      var geocoder = new google.maps.Geocoder()
      geocoder.geocode({'location': latlng}, (results, status) => {
        if (status === 'OK') {
            if (results[0]) {

                console.log(results[0])
                this.currentPlace = results[0]

                // console.log("lat: "+ results[0].geometry.location.lat().toFixed(6))
                // console.log("lng: "+ results[0].geometry.location.lng().toFixed(6))
                // let _lat = results[0].geometry.location.lat().toFixed(6)
                // let _lng = results[0].geometry.location.lng().toFixed(6)

                // $this.lat = _lat
                // $this.lng = _lng
                // let marker = {
                //   lat: parseFloat(_lat),
                //   lng: parseFloat(_lng)
                // }

                if (field === 'origin') {
                    $this.origin = marker
                    $this.$refs.origin.$el.value = results[0].formatted_address
                    $this.markers.push({ position: marker })
                    $this.places.push($this.currentPlace)
                    $this.currentPlace = null
                }
                else if (field === 'destination') {
                    $this.destination = marker
                    $this.$refs.destination.$el.value = results[0].formatted_address
                    $this.markers.push({ position: marker })
                    $this.places.push($this.currentPlace)
                    $this.currentPlace = null
                }
                else {
                    $this.$refs.stop[field].$el.value = results[0].formatted_address
                    $this.currentWaypoint = results[0]
                    console.log("** lat/lng **")
                    console.log(marker.lat + ', '+ marker.lng)

                    var gps = new google.maps.LatLng(marker.lat, marker.lng);

                    $this.waypoints.push({location: gps, stopover: true})

                    // $this.waypoints.push({
                    //       location: new google.maps.LatLng(marker.lat, marker.lng),
                    //       //location: {lat: marker.lat, lng: marker.lng},
                    //       stopover: true
                    // })  //  [{location: first, stopover: true}],

                    $this.places.push($this.currentWaypoint)
                    $this.markers.push({ position: marker })
                    $this.currentWaypoint = null
                }
            }
        }
        else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    },

    // findLocation (field) {
    //   let value = ''

    //   if (field === 'origin')
    //       value = this.$refs.origin.$el.value
    //   else if (field === 'destination')
    //       value = this.$refs.destination.$el.value
    //   else
    //       value = this.$refs.stop[0].$el.value   // eval("this.$refs."+  field +".$el.value")

    //   var geocoder = new google.maps.Geocoder();
    //   geocoder.geocode({'address': value}, (results, status) => {
    //     if (status === 'OK') {
    //       let marker = {
    //           lat: results[0].geometry.location.lat(),
    //           lng: results[0].geometry.location.lng()
    //         }
    //         this.markers.push({ position: marker })
    //         this.centerMap()
    //     }
    //     else {
    //       alert('Geocode was not successful for the following reason: ' + status);
    //     }
    //   });
    // },
    setWaypoint (place) {
      this.currentWaypoint = place
      this.addMarker('waypoint')
    },
    dragend (index, e) {
        const $this = this
        const field = this.targetField
        this._map.panTo(e.latLng)
        var geocoder = new google.maps.Geocoder()
        let latlng = {lat: parseFloat(e.latLng.lat()), lng: parseFloat(e.latLng.lng())};

        console.log(latlng)

        geocoder.geocode({'location': latlng}, (results, status) => {
        if (status === 'OK') {

            if (results[0]) {
                $this.currentPlace = results[0]
                $this.lat = e.latLng.lat().toFixed(6)
                $this.lng = e.latLng.lng().toFixed(6)

                if (field === 'origin') {
                    $this.$refs.origin.$el.value = results[0].formatted_address
                }
                else if (field === 'destination') {
                    $this.$refs.destination.$el.value = results[0].formatted_address
                }
                else {
                    $this.$refs.stop[field].$el.value = results[0].formatted_address
                }
            }
        }
        else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    },
    addMarker (action) {

      // console.log('** default location **')
      // console.log(this.defaultLocation)
      // console.log(this.defaultLocation.lat +", "+ this.defaultLocation.lng)

      if (this.places.length > 0 && this.markers.length === 0) {
          for (let i=0; i < this.places.length; i++) {
              this.markers.push({
                position: {
                  lat: this.places[i].geometry.location.lat(),
                  lng: this.places[i].geometry.location.lng()
                }
              })
          }
      }

      if (this.currentPlace || this.currentWaypoint) {
        let marker = null
        if (action === 'waypoint') {
            marker = {
              lat: this.currentWaypoint.geometry.location.lat(),
              lng: this.currentWaypoint.geometry.location.lng()
            }
            this.waypoints.push({
                location: this.currentWaypoint.geometry.location,
                stopover: true
            })

            this.places.push(this.currentWaypoint)
            this.markers.push({ position: marker })
            this.currentWaypoint = null
        }
        else {
            marker = {
              lat: this.currentPlace.geometry.location.lat(),
              lng: this.currentPlace.geometry.location.lng()
            }

            if (this.targetObject === 'origin') {
                this.origin = marker
                if (this.places[0] === undefined) {
                    this.places.push(this.currentPlace)
                    this.markers.push({ position: marker })
                }
                else {
                    this.places.splice(0, 1, this.currentPlace);
                    this.markers.splice(0, 1, {position: marker});
                }
            }
            else if (this.targetObject === 'destination') {
                this.destination = marker
                if (this.places[1] === undefined) {
                    this.places.push(this.currentPlace)
                    this.markers.push({ position: marker })
                }
                else {
                    this.places.splice(1, 1, this.currentPlace);
                    this.markers.splice(1, 1, {position: marker});
                }
            }

            this.currentPlace = null

            if ( !!this.$refs.destination.$el.value ) {
                this.$refs.destination.$el.focus()
            }
        }


        this.clearRoutes()
        this.centerMap()

        // this.center = marker
        // let bounds = new google.maps.LatLngBounds()

        // for (let i = 0; i < this.markers.length; i++) {
        //   bounds.extend(this.markers[i].position)
        // }
        // this._map.fitBounds(bounds)
        // if (this.markers.length === 1) {
        //     this._map.setZoom(9)
        // }

        // if (this.markers.length > 1) {
        //     this.findDirection()
        // }
      }
    },
    centerMap() {
        let bounds = new google.maps.LatLngBounds()

        for (let i = 0; i < this.markers.length; i++) {
          bounds.extend(this.markers[i].position)
        }
        this._map.fitBounds(bounds)
        if (this.markers.length === 1) {
            this._map.setZoom(9)
        }

        console.log( this._map.getCenter() )
        // console.log('map.getCenter() = '+ this._map.getCenter() )
        this.center = this._map.getCenter().lat()+','+this._map.getCenter().lng()
    },
    addStop(e) {
      this.stops.push({
        location: ''
      })
    },
    clearRoutes () {
      // Clear past routes
      if (this.directionsDisplay != null) {
          this.directionsDisplay.setMap(null)
          this.directionsDisplay = null
      }
      this.clearSegmentMarkers()

      // clear custom polyline
      for (var i=0; i < this.all_overlays.length; i++) {
        this.all_overlays[i].overlay.setMap(null);
      }
    },

    clearSegmentMarkers () {
      for (var i=0; i < this.segmentMarkers.length; i++){
        this.segmentMarkers[i].setMap(null);
      }
    },
    resetForm (e) {
      this.markers = []
      this.places = []
      this.waypoints = []
      this.stops = []
      this.origin = null
      this.destination = null
      this.currentPlace = null
      this.currentWaypoint = null

      this.$refs.origin.$el.value = ""
      this.$refs.destination.$el.value = ""
      this.$refs.origin.$el.focus()

      // zoom map to original
      this._map.setZoom(7)
      let initLocation = new google.maps.LatLng(this.defaultLocation.lat, this.defaultLocation.lng)
      this._map.setCenter(initLocation);

      this.disabledCapture = true

      this._map.setOptions({draggableCursor:''})

      this.clearRoutes()
    },
    // geolocate () {
    //   navigator.geolocation.getCurrentPosition(position => {
    //     this.center = {
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude
    //     }
    //   })
    // },


    calculateAndDisplayRoute (directionsService, directionsDisplay, start, destination, _waypoints) {
        // console.log("*** waypoints ***")
        // console.log(_waypoints)
        // console.log(_waypoints[0].location.lat() +", "+ _waypoints[0].location.lng())
        // console.log("*** waypoints ***")
        // var first = new google.maps.LatLng(14.638857, 43.302278);
        // var _wp = []
        // for (var i in _waypoints) {
        //     //_wp.push( {location: new google.maps.LatLng(_waypoints[i].lat, _waypoints[i].lng), stopover: true} )
        //     _wp.push( {location: first, stopover: true} )
        // }
        //
        // console.log("*******************")
        // console.log("Start: "+ start.lat +", "+ start.lng)
        // console.log("Waypoints: ")
        // for (var i in _waypoints) {
        //     console.log(_waypoints[i].location.lat()+", "+ _waypoints[i].location.lng())
            //_wp.push( {location: new google.maps.LatLng(_waypoints[i].lat, _waypoints[i].lng), stopover: true} )
            //_wp.push( {location: first, stopover: true} )
        // }
        // console.log("Destination: "+ destination.lat +", "+ destination.lng)
        // console.log("*******************")

        this.directionsService.route({
          //origin: start.lat +','+ start.lng, //'14.517158, 43.316214',
          //destination: destination.lat + ','+ destination.lng, //'14.638857, 43.302278',
          origin: start,
          destination: destination,
          waypoints: _waypoints,
          //waypoints: [{location: first, stopover: true}],
          optimizeWaypoints: true,
          travelMode: this.travelMode
        }, function(response, status) {
          if (status === 'OK') {
              console.log('****')
              console.log(response)
              console.log('****')
              directionsDisplay.setDirections(response);
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });

        // this.directionsService.route({
        //   origin: start,
        //   destination: destination,
        //   waypoints: waypoints,
        //   optimizeWaypoints: true,
        //   travelMode: this.travelMode //'DRIVING'
        // }, function (response, status) {
        //   console.log('* response *')
        //   console.log(response)

        //   if (status === 'OK') {

        //       directionsDisplay.setDirections(response)

        //   } else {
        //     window.alert('Directions request failed due to ' + status)
        //   }
        // })
    },

    createMarker(latlng, label, color) {

        if (!latlng) return
        let _this = this
        let contentString = '<b>'+label+'</b><br>'+ latlng.lat().toFixed(6) +', '+ latlng.lng().toFixed(6)
        let marker = new google.maps.Marker({
                            position: latlng,
                            map: _this._map,
                            icon: {
                              path: google.maps.SymbolPath.CIRCLE,
                                    path: google.maps.SymbolPath.CIRCLE,
                                    scale: 4,
                                    fillColor: color,
                                    fillOpacity: 1,
                                    strokeWeight: 1
                            },
                            title: label })

          _this.segmentMarkers.push(marker)
          marker.addListener('mouseover', function() {
              infowindow.setContent(contentString)
              infowindow.open(_this._map, this);
          })

          marker.addListener('mouseout', function() {
              infowindow.close();
          });
        return marker;
    },

    computeTotalDistance(result) {

        let _this = this

        _this.clearSegmentMarkers()
        let routes = result.routes[0];

        // console.log("***** kupal here *****")
        // console.log( _this.$refs.origin )
        // console.log("***** kupal here *****")
        //console.log(JSON.stringify(routes))

        let legs = result.routes[0].legs;
        _this.$refs.origin.$el.value = legs[0].start_address
        _this.$refs.destination.$el.value = legs[legs.length-1].end_address

        let waypoint_order = result.routes[0].waypoint_order

        for (var idx in waypoint_order) {
             let value = waypoint_order[idx]
             _this.$refs.stop[idx].$el.value = legs[value].end_address
        }

        let totalDistance = 0;
        let totalDuration = 0;
        var polyline = new google.maps.Polyline({
            path: [],
            strokeColor: '#FF0000',
            strokeWeight: 3
        })

        // console.log(polyline)
        // keep previous marker
        // _this.old_markers = _this.markers


        _this.segmentMarkers = new Array()
        _this.markers = new Array()

        // console.log("start address: "+ legs[0].start_address)
        // console.log("end address: "+ legs[legs.length-1].end_address)

        // alert(this.$refs.origin.$el.value)

        // this.$refs.origin.$el.value = "Kupal 1"
        // this.$refs.destination.$el.value = "Kupal 2"

        // this.$refs.origin.$el.value = legs[0].start_address
        // this.$refs.destination.$el.value = legs[legs.length-1].end_address

        for (var i=0;i<legs.length;i++) {
          totalDistance += legs[i].distance.value;
          totalDuration += legs[i].duration.value;

          var steps = legs[i].steps;
          for (var j=0;j<steps.length;j++) {
            var nextSegment = steps[j].path;

            for (var k=0;k<nextSegment.length;k++) {
              polyline.getPath().push(nextSegment[k]);
            }
          }
        }

        let totalDistanceKM = totalDistance/1000;
        let segment = (totalDistanceKM / 20);
        let totKM = 20;

        for (var i=0; i < segment; i++) {

          let obj = polyline.GetPointAtDistance(totKM*1000)
          if (obj !== null) {
              // let lat = polyline.GetPointAtDistance(totKM*1000).lat().toFixed(6)
              // let lng = polyline.GetPointAtDistance(totKM*1000).lng().toFixed(6)
              _this.createMarker(polyline.GetPointAtDistance(totKM*1000), totKM +"km",'yellow');
          }

          totKM+=20;
        }
    },

    findDirection () {

      if (this.markers.length <= 1) {
          //alert('** len **'+ this.markers.length)
          return
      }

      // enable capture button
      this.disabledCapture = false

      let gmarkers = [];
      let _this = this;
      //let directionsService = new google.maps.DirectionsService()
      this.directionsService = new google.maps.DirectionsService()


      // Clear past routes
      if (this.directionsDisplay != null) {
          this.directionsDisplay.setMap(null);
          this.directionsDisplay = null;
      }

      // initialize direction display
      this.directionsDisplay = new google.maps.DirectionsRenderer({
        draggable: true,
        // suppressMarkers: true,
        map: this._map
      })

      // this.showRouteInfo = true;
      // this.origin = this.$refs.origin.$el.value
      // this.destination = this.$refs.destination.$el.value

      // google maps API's direction service
      // function _calculateAndDisplayRoute (directionsService, directionsDisplay, start, destination, waypoints) {

      //   directionsService.route({
      //     origin: start,
      //     destination: destination,
      //     waypoints: waypoints,
      //     optimizeWaypoints: true,
      //     travelMode: _this.travelMode //'DRIVING'
      //   }, function (response, status) {
      //     console.log('* response *')
      //     console.log(response)

      //     if (status === 'OK') {

      //         directionsDisplay.setDirections(response)

      //     } else {
      //       window.alert('Directions request failed due to ' + status)
      //     }
      //   })
      // }

      let infowindow = new google.maps.InfoWindow({
            size: new google.maps.Size(150,50)
          });

      // function _createMarker(latlng, label, color) {

      //   if (!latlng) return

      //   let contentString = '<b>'+label+'</b><br>'+ latlng.lat().toFixed(6) +', '+ latlng.lng().toFixed(6)
      //   let marker = new google.maps.Marker({
      //                       position: latlng,
      //                       map: _this._map,
      //                       icon: {
      //                         path: google.maps.SymbolPath.CIRCLE,
      //                               path: google.maps.SymbolPath.CIRCLE,
      //                               scale: 4,
      //                               fillColor: color,
      //                               fillOpacity: 1,
      //                               strokeWeight: 1
      //                       },
      //                       title: label })

      //     _this.segmentMarkers.push(marker)
      //     marker.addListener('mouseover', function() {
      //         infowindow.setContent(contentString)
      //         infowindow.open(_this._map, this);
      //     })

      //     marker.addListener('mouseout', function() {
      //         infowindow.close();
      //     });
      //   return marker;
      // }

      // function _computeTotalDistance(result) {


      //   _this.clearSegmentMarkers()
      //   let routes = result.routes[0];

      //   // console.log("***** kupal here *****")
      //   // console.log( _this.$refs.origin )
      //   // console.log("***** kupal here *****")
      //   //console.log(JSON.stringify(routes))

      //   let legs = result.routes[0].legs;
      //   _this.$refs.origin.$el.value = legs[0].start_address
      //   _this.$refs.destination.$el.value = legs[legs.length-1].end_address

      //   let waypoint_order = result.routes[0].waypoint_order

      //   for (var idx in waypoint_order) {
      //        let value = waypoint_order[idx]
      //        _this.$refs.stop[idx].$el.value = legs[value].end_address
      //   }

      //   let totalDistance = 0;
      //   let totalDuration = 0;
      //   var polyline = new google.maps.Polyline({
      //       path: [],
      //       strokeColor: '#FF0000',
      //       strokeWeight: 3
      //   })

      //   // console.log(polyline)

      //   _this.segmentMarkers = new Array()
      //   _this.markers = new Array()

      //   // console.log("start address: "+ legs[0].start_address)
      //   // console.log("end address: "+ legs[legs.length-1].end_address)

      //   // alert(this.$refs.origin.$el.value)

      //   // this.$refs.origin.$el.value = "Kupal 1"
      //   // this.$refs.destination.$el.value = "Kupal 2"

      //   // this.$refs.origin.$el.value = legs[0].start_address
      //   // this.$refs.destination.$el.value = legs[legs.length-1].end_address

      //   for (var i=0;i<legs.length;i++) {
      //     totalDistance += legs[i].distance.value;
      //     totalDuration += legs[i].duration.value;

      //     var steps = legs[i].steps;
      //     for (var j=0;j<steps.length;j++) {
      //       var nextSegment = steps[j].path;

      //       for (var k=0;k<nextSegment.length;k++) {
      //         polyline.getPath().push(nextSegment[k]);
      //       }
      //     }
      //   }

      //   let totalDistanceKM = totalDistance/1000;
      //   let segment = (totalDistanceKM / 20);
      //   let totKM = 20;

      //   for (var i=0; i < segment; i++) {

      //     let obj = polyline.GetPointAtDistance(totKM*1000)
      //     if (obj !== null) {
      //         // let lat = polyline.GetPointAtDistance(totKM*1000).lat().toFixed(6)
      //         // let lng = polyline.GetPointAtDistance(totKM*1000).lng().toFixed(6)
      //         this.createMarker(polyline.GetPointAtDistance(totKM*1000), totKM +"km",'yellow');
      //     }

      //     totKM+=20;
      //   }
      // }

       this.directionsDisplay.addListener('directions_changed', function (e) {
          _this.computeTotalDistance(_this.directionsDisplay.getDirections())
      })

      if (_this.markers.length > 0) {
          _this.old_markers = _this.markers
      }

      // this.calculateAndDisplayRoute(_this.directionsService, _this.directionsDisplay, this.markers[0].position, this.markers[this.markers.length-1].position, this.waypoints)
      this.calculateAndDisplayRoute(_this.directionsService, _this.directionsDisplay, this.origin, this.destination, this.waypoints)
    },

   createMarker(latlng, label, color) {
        let _self = this

        let infowindow = new google.maps.InfoWindow({
            size: new google.maps.Size(150,50)
          });

        if (!latlng) return

        let contentString = '<b>'+label+'</b><br>'+ latlng.lat().toFixed(6) +', '+ latlng.lng().toFixed(6)
        let marker = new google.maps.Marker({
                            position: latlng,
                            map: _self._map,
                            icon: {
                              path: google.maps.SymbolPath.CIRCLE,
                                    path: google.maps.SymbolPath.CIRCLE,
                                    scale: 4,
                                    fillColor: color,
                                    fillOpacity: 1,
                                    strokeWeight: 1
                            },
                            title: label })

          _self.segmentMarkers.push(marker)
          marker.addListener('mouseover', function() {
              infowindow.setContent(contentString)
              infowindow.open(_self._map, this);
          })

          marker.addListener('mouseout', function() {
              infowindow.close();
          });
        return marker;
    }

  },
  computed: {
      isEnableDirection () {
        return (this.places[0] === undefined || this.places[1] === undefined)
      }
  },
  mounted () {

    let _self = this
    this.$refs.mapRef.$mapPromise.then((map) => {
      _self._map = map
      _self._map.setOptions({ minZoom: 7, maxZoom: 22, draggableCursor:''});
      _self._map.addListener('click', _self.mapClickEventHandler.bind(_self));

      // var centerControlDiv = document.createElement('div');
      // var centerControl = _self.centerControl(centerControlDiv, map);

      // centerControlDiv.index = 1;
      // map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);

      var drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.MARKER,
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['polyline'] // 'marker', 'circle', 'polygon', 'rectangle'
          },

          polylineOptions: {
            strokeColor: '#426289',
            fillOpacity: 1,
            strokeWeight: 5,
            clickable: false,
            editable: false,
            zIndex: 1
          }

      });

      drawingManager.setMap(this._map)

      google.maps.event.addListener(drawingManager, 'overlaycomplete', function(e) {
          _self.all_overlays.push(e);
      });

      google.maps.event.addListener(drawingManager, 'markercomplete', function(e) {
          console.log(e.position.lat() +", "+ e.position.lng())
          _self.mapClickEventHandler(e)

      });

      google.maps.event.addListener(drawingManager, 'polylinecomplete', function(polyline) {

          _self.disabledCapture = false

          let o = polyline.getPath().getArray()
          let polyLengthInMeters = google.maps.geometry.spherical.computeLength(o);


          _self.overview_polyline = google.maps.geometry.encoding.encodePath(polyline.getPath());

          _self.polyline = o

          console.log( "encodeString: "+ _self.overview_polyline )

          for (var i = 0; i < o.length; i++) {
            console.log(o[i].lat() +", "+ o[i].lng())

            if (i === 0) {
                _self.markers.push({
                    position: {
                      lat: o[i].lat(),
                      lng: o[i].lng()
                    }
                })
            }
            else if (i+1 == o.length) {
                 _self.markers.push({
                    position: {
                      lat: o[i].lat(),
                      lng: o[i].lng()
                    }
                })
            }
          }

          // calculate 20km segment
          let totalDistanceKM = polyLengthInMeters/1000;
          let segment = (totalDistanceKM / 20);
          let totKM = 20;

          for (var i=0; i < segment; i++) {

            let obj = polyline.GetPointAtDistance(totKM*1000)
            if (obj !== null) {
                _self.createMarker(polyline.GetPointAtDistance(totKM*1000), totKM +"km",'yellow');
            }

            totKM+=20;
          }
      })

      google.maps.LatLng.prototype.distanceFrom = function(newLatLng) {
        var EarthRadiusMeters = 6378137.0; // meters
        var lat1 = this.lat();
        var lon1 = this.lng();
        var lat2 = newLatLng.lat();
        var lon2 = newLatLng.lng();
        var dLat = (lat2-lat1) * Math.PI / 180;
        var dLon = (lon2-lon1) * Math.PI / 180;
        var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(lat1 * Math.PI / 180 ) * Math.cos(lat2 * Math.PI / 180 ) *
          Math.sin(dLon/2) * Math.sin(dLon/2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d = EarthRadiusMeters * c;
        return d;
      }

      google.maps.Polyline.prototype.GetPointAtDistance = function(metres) {
          // some awkward special cases
          if (metres == 0) return this.getPath().getAt(0);
          if (metres < 0) return null;
          if (this.getPath().getLength() < 2) return null;
          var dist=0;
          var olddist=0;
          for (var i=1; (i < this.getPath().getLength() && dist < metres); i++) {
            olddist = dist;
            dist += this.getPath().getAt(i).distanceFrom(this.getPath().getAt(i-1));
          }
          if (dist < metres) {
            return null;
          }
          var p1= this.getPath().getAt(i-2);
          var p2= this.getPath().getAt(i-1);
          var m = (metres-olddist)/(dist-olddist);
          return new google.maps.LatLng( p1.lat() + (p2.lat()-p1.lat())*m, p1.lng() + (p2.lng()-p1.lng())*m);
      }

    })

    // window listener
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.mapStyles = 'width: 100%; height:' + (window.innerHeight - 250) + 'px'
        this.routeInfoStyle = 'padding:0px;position:relative; height:'+ (window.innerHeight - 500) +'px; overflow-y:scroll;'
      })
    })
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.vue-map-container,
.vue-map-container .vue-map {
    width: 100%;
    height: 100%;
}

#floating-panel {
  position: absolute;
  top: 5px;
  left: 20%;
  z-index: 5;
  background-color: #fff;
  /*padding: 5px;*/
  border: 1px solid #999;
  text-align: center;
  font-family: 'Roboto','sans-serif';
  line-height: 30px;
  /*padding-left: 10px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/map/MapPanel.vue